/** FEREASTRA DE REDENUMIT UN MODUL — una singură, pentru toate ecranele.
 *
 *  Era numai în colecție. Arhitectul a cerut-o și în editor (26.10.2026: «să
 *  fie buton de redenumește și în editare»), iar a doua copie a aceluiași câmp
 *  ar fi însemnat a doua oară regula numelui și a doua oară capcana de mai jos.
 *
 *  CÂMPUL NU TRANSFORMĂ CE SE TASTEAZĂ. Un `<input>` controlat căruia îi dai
 *  înapoi altă valoare decât cea din DOM își duce cursorul la CAPĂT: scrii o
 *  literă în mijlocul numelui și următoarea ajunge la sfârșit, iar o bucată
 *  lipită se rupe la fel — «să poți să faci copy și paste și să poți scrie în
 *  orice punct fără întrerupere». Majusculele se văd din `.ob-majuscule`, iar
 *  numele se curăță abia la trimitere (`api.numeCurat`).
 */
import { useState } from "react";
import * as api from "../api";
import { useT } from "../i18n";

export default function DialogRedenumire({ cod, lucrez, laRenunta, laNume }: {
  /** Numele de acum — se arată în titlu și e cel din care se pornește. */
  cod: string;
  lucrez?: boolean;
  laRenunta: () => void;
  /** Primește numele CANONIC; cine o cheamă face cererea și închide. */
  laNume: (nou: string) => void;
}) {
  const t = useT();
  const [nume, setNume] = useState(cod);
  const curat = api.numeCurat(nume);
  const bun = api.NUME_MODUL.test(curat);
  const trimite = () => { if (bun && !lucrez) laNume(curat); };

  return (
    <div className="ob-tr-nou-fundal" onClick={laRenunta}>
      <div className="ob-tr-nou card ob-tr-renume" role="dialog"
           aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <h2>{t("colectie.redenumeste_titlu", { cod })}</h2>
        <label className="ob-camp">
          <span>{t("colectie.redenumeste_camp")}</span>
          <input value={nume} autoFocus maxLength={api.LUNGIME_COD}
                 className="ob-majuscule"
                 onChange={(e) => setNume(e.target.value)}
                 onKeyDown={(e) => { if (e.key === "Enter") trimite(); }} />
        </label>
        <p className="note">{t("colectie.redenumeste_regula",
                               { n: api.LUNGIME_COD })}</p>
        <div className="ob-tr-nou-butoane">
          <button type="button" className="ob-btn" onClick={laRenunta}>
            {t("comun.renunta")}
          </button>
          <button type="button" className="ob-btn primar"
                  disabled={!!lucrez || !bun} onClick={trimite}>
            {t("colectie.redenumeste")}
          </button>
        </div>
      </div>
    </div>
  );
}
